import { useAtom } from "jotai";
import { searchResultsAtom } from "../atoms/searchAtom";
import { FIVE_MINUTES_MS } from "../utils/consts";
import apiClient from "./apiClient";
import { toast } from "sonner";

export const useSearchService = () => {
  const [searchResults, setSearchResults] = useAtom(searchResultsAtom);

  const simpleSearch = async (query: string) => {
    try {
      if (
        query === searchResults.query &&
        searchResults.lastFetched &&
        Date.now() - searchResults.lastFetched < FIVE_MINUTES_MS
      ) {
        // Same response is already cached
        return;
      }
      setSearchResults((prev) => ({ ...prev, data: [], loading: true }));
      const response = await apiClient.post(
        `/search`,
        {
          generalQuery: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      setSearchResults((_prev) => ({
        loading: false,
        data: response.data,
        query,
        lastFetched: Date.now(),
      }));
      return response;
    } catch (error) {
      setSearchResults((prev) => ({
        ...prev,
        loading: false,
        data: [],
        query: "",
      }));
      toast.error("No search results for that criteria.");
      throw error;
    }
  };

  return {
    simpleSearch,
    searchResults: searchResults.data,
    searchLoading: searchResults.loading,
  };
};
